import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from '../locales/en/common.json';
import enLogin from '../locales/en/login.json';
import enTopbar from '../locales/en/topbar.json';
import enEmails from '../locales/en/emails.json';
import enSidebar from '../locales/en/sidebar.json';
import elCommon from '../locales/el/common.json';
import elLogin from '../locales/el/login.json';
import elTopbar from '../locales/el/topbar.json';
import elEmails from '../locales/el/emails.json';
import elSidebar from '../locales/el/sidebar.json';
import { moduleNamespaces, moduleResources } from './registerModules';

const storedLanguage =
  typeof window !== 'undefined' ? localStorage.getItem('uiLanguage') : null;
const UI_LANGUAGE = storedLanguage === 'el' ? 'el' : 'en';

const baseResources = {
  en: { common: enCommon, login: enLogin, topbar: enTopbar, emails: enEmails, sidebar: enSidebar },
  el: { common: elCommon, login: elLogin, topbar: elTopbar, emails: elEmails, sidebar: elSidebar },
};

i18n.use(initReactI18next).init({
  resources: {
    en: { ...baseResources.en, ...moduleResources.en },
    el: { ...baseResources.el, ...moduleResources.el },
  },
  lng: UI_LANGUAGE,
  fallbackLng: 'en',
  defaultNS: 'common',
  ns: ['common', 'login', 'topbar', 'emails', 'sidebar', ...moduleNamespaces],
  interpolation: { escapeValue: false },
});

document.documentElement.lang = UI_LANGUAGE;

export default i18n;
